import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LineItemDiscount = ({
  currencyCode,
  discountAmount,
  unadjustedAmount,
  value,
  valueType
}) => /*#__PURE__*/_jsxs(Flex, {
  display: "flex",
  children: [/*#__PURE__*/_jsx(Text, {
    "data-test-id": "line-item-price",
    as: "small",
    children: /*#__PURE__*/_jsx("s", {
      children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
        value: unadjustedAmount,
        currencyCode: currencyCode
      })
    })
  }), /*#__PURE__*/_jsx(Text, {
    typography: "heading-25",
    "data-test-id": "line-item-discount",
    marginInlineStart: "100",
    color: "text-positive-default",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "payments.afterDiscount",
      options: {
        discountValue: valueType === 'PERCENT' ? /*#__PURE__*/_jsx(FormattedPercentage, {
          value: value,
          precision: 5
        }) : /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: discountAmount,
          currencyCode: currencyCode
        })
      }
    })
  })]
});
export default LineItemDiscount;